
import { parseStackFrames } from "../utils/parseErrorStk";
import type { MonitorSdk, MonitorPlugin } from "../types/type";

export default class BrowserRequest implements MonitorPlugin {
  options: {
    exclude: string[];
  };

  constructor(options) {
    this.options = options || {};
  }

  init(sdk: MonitorSdk) {
    if (typeof window === 'undefined') return;
    this.overwriteXHR(sdk);
    this.overwriteFetch(sdk);
  }

  overwriteXHR(sdk: MonitorSdk) {
    const originalOpen = XMLHttpRequest.prototype.open;
    const originalSend = XMLHttpRequest.prototype.send;

    const exclude = this.options.exclude || [];


    XMLHttpRequest.prototype.open = function (_method, url /*, async, user, password */) {
      (this as any)._url = url; // 保存请求的 URL
      // @ts-ignore
      return originalOpen.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function (_body) {
      const startTime = Date.now(); // 请求开始时间

      const url = (this as any)._url;
      if (!url || url.indexOf('/monitorApi/') > -1 || exclude.some((pattern) => url.includes(pattern))) {
        // @ts-ignore
        return originalSend.apply(this, arguments);
      }

      const getSimpleTraceId = () => {
        // 跨域问题
        if (url.indexOf('/sea_shell/') === -1) return ''
        return this.getResponseHeader('Simple-Traceid') || ''
      }

      const onReadyStateChange = (_event) => {
        if (this.readyState === XMLHttpRequest.DONE) {
          const duration = Date.now() - startTime; // 请求持续时间
          const status = this.status; // HTTP 状态码
          const ok = status >= 200 && status < 300;
          sdk.report({
            module: 'request',
            action: ok ? 'xhr' : 'xhr_error',
            status: String(status),
            target: url,
            elapsed: duration,
            logs: ({ ['Simple-Traceid']: getSimpleTraceId(), statusText: this.statusText }),
          });
        }
      };

      const onError = (_event) => {
        sdk.report({
          module: 'request',
          action: 'xhr_error',
          status: String(this.status),
          target: (this as any)._url,
          logs: ({ ['Simple-Traceid']: getSimpleTraceId(), statusText: this.statusText }),
        });
      }

      this.addEventListener('readystatechange', onReadyStateChange);
      this.addEventListener('error', onError);

      // @ts-ignore
      return originalSend.apply(this, arguments);
    };
  }

  overwriteFetch(sdk: MonitorSdk) {
    const originalFetch = window.fetch;
    const exclude = this.options.exclude || [];

    window.fetch = function (...args) {
      const [resource, _config] = args;
      const startTime = Date.now(); // 请求开始时间

      if (typeof resource === 'string' && (resource.indexOf('/monitorApi/') > -1 || exclude.some((pattern) => resource.includes(pattern)))) {
        return originalFetch.apply(this, args);
      }

      return originalFetch.apply(this, args).then((response) => {
        const duration = Date.now() - startTime; // 请求持续时间
        const status = response.status; // HTTP 状态码
        const headers = response.headers;

        let simpleTraceId = ''
        if (typeof resource === 'string' && resource.indexOf('/sea_shell/') > -1) {
          simpleTraceId = headers.get('Simple-Traceid') || '';
        }

        sdk.report({
          module: 'request',
          action: response.ok ? 'fetch' : 'fetch_error',
          status: String(status),
          target: resource.toString(),
          elapsed: duration,
          logs: ({ ['Simple-Traceid']: simpleTraceId, statusText: response.statusText }),
        });
        return response;
      }).catch((error) => {
        const duration = Date.now() - startTime;
        const stk = parseStackFrames(error, 10);

        sdk.report({
          module: 'request',
          action: 'fetch_error',
          status: 'catch',
          target: resource.toString(),
          elapsed: duration,
          logs: (stk),
        });
        const count = (error.__monitor_stk_count__ || 0) + 1;
        (error.__monitor_stk_count__) = count;
        throw error // 继续抛出错误以便调用者处理
      });

    };
  }
}